import { AgxEmptyState, AgxSpacer } from '@urbanx/agx.ui-components2'
import { JSX } from 'react'

interface AwaitingAgentApprovalBlockerProps {
  onApprovalReceived: () => void
}

export const AwaitingAgentApprovalBlocker = ({ 
  onApprovalReceived 
}: AwaitingAgentApprovalBlockerProps): JSX.Element => {
  return (
    <AgxSpacer
      fill
      contentJustification="center"
      contentAlignment="center"
    >
      <AgxEmptyState
        variant="advanced"
        glyphType="locked"
        actionButtons={[
          {
            label: 'Confirm Approval',
            isPrimary: true,
            order: 1,
            onClick: onApprovalReceived,
          },
        ]}
        label="Approval Received Not Confirmed"
        description="Confirm agent approval to progress the launch task."
      />
    </AgxSpacer>
  )
}
